import React from 'react';
import { Card, Badge } from './ui';
import { CheckCircle, Book, BookOpen, BookMarked, Library, Notebook, BookType, Gift, Salad } from 'lucide-react';
export function Product() {
  const tomos = [{
    icon: <Book className="w-8 h-8 text-brand-300" data-id="element-92" data-mp="28c3n8v8uzlj8" />,
    color: 'bg-brand-500/10 border-brand-500/20',
    title: 'TOMO 1 — Hamburguesas, Albóndigas y Medallones',
    subtitle: 'Las favoritas de la casa, ahora más nutritivas',
    desc: 'Cómo integrar verduras dentro de la mezcla para que queden jugosas, firmes y sin un solo trozo visible.'
  }, {
    icon: <BookOpen className="w-8 h-8 text-brand-400" data-id="element-93" data-mp="2r2blp01m5nt3" />,
    color: 'bg-brand-500/10 border-brand-500/20',
    title: 'TOMO 2 — Nuggets, Milanesas, Bastones y Croquetas',
    subtitle: 'Rebozados que sí aceptan sin discutir',
    desc: 'Recetas y técnicas para lograr el crocante de siempre con verduras completamente incorporadas.'
  }, {
    icon: <BookMarked className="w-8 h-8 text-brand-300" data-id="element-94" data-mp="2vys8nqx2tw4l" />,
    color: 'bg-brand-500/10 border-brand-500/20',
    title: 'TOMO 3 — Pizzas, Tartas y Empanadas',
    subtitle: 'Rellenos y masas con verduras integradas',
    desc: 'Cómo sumar verduras a masas y rellenos sin cambiar el sabor ni el aspecto que ya les gusta.'
  }, {
    icon: <Library className="w-8 h-8 text-brand-400" data-id="element-95" data-mp="29k6wm1ihcp32" />,
    color: 'bg-brand-500/10 border-brand-500/20',
    title: 'TOMO 4 — Pastas y Salsas Invisibles',
    subtitle: 'Salsas suaves, cremosas y sin grumos',
    desc: 'Salsas y pastas donde las verduras desaparecen por completo en textura, color y sabor.'
  }, {
    icon: <Notebook className="w-8 h-8 text-brand-300" data-id="element-96" data-mp="2o9csbfi3zx67" />,
    color: 'bg-brand-500/10 border-brand-500/20',
    title: 'TOMO 5 — Desayunos, Meriendas y Snacks',
    subtitle: 'Muffins, panqueques, licuados y bocaditos',
    desc: 'Opciones simples para sumar verduras también fuera del almuerzo y la cena.'
  }, {
    icon: <BookType className="w-8 h-8 text-brand-400" data-id="element-97" data-mp="126cnlwhud4cg" />,
    color: 'bg-brand-500/10 border-brand-500/20',
    title: 'TOMO 6 — Postres con Verduras Invisibles',
    subtitle: 'Dulces que nadie sospecharía',
    desc: 'Bizcochuelos, brownies y postres caseros con verduras totalmente integradas.'
  }];
  return <section className="py-12 px-4 bg-slate-900/30 pt-[4px] pb-[4px]" data-id="element-98" data-mp="174xoly4x3s1y">
      <div className="max-w-5xl mx-auto" data-id="element-99" data-mp="173moq9elf4g4">
        <div className="text-center mb-10" data-id="element-100" data-mp="1ltaoh674lv1q">
          <Badge variant="success" className="mb-4" data-id="element-101" data-mp="1lwgagckgkgt8">MEGAPACK VERDURAS INVISIBLES — 6 TOMOS + 5 BONOS</Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-102" data-mp="1gxlo50na8a4d">
            UNA FORMA MÁS SIMPLE DE INCORPORAR VERDURAS EN LAS COMIDAS QUE YA LES GUSTAN
          </h2>
          <p className="text-xl text-slate-400" data-id="element-103" data-mp="1pwqg1o4c957k">
            Aprendé recetas y técnicas para integrar verduras dentro de hamburguesas, nuggets, pizzas, pastas, meriendas y postres sin que queden trozos visibles.
          </p>
          <div className="flex flex-wrap justify-center gap-2 mt-6 text-sm font-medium text-brand-400" data-id="element-104" data-mp="2759j31nc6umu">
            <span data-id="element-105" data-mp="2c42zp2xx71r8">Sin trozos visibles</span><span className="text-slate-600" data-id="element-106" data-mp="2c3b25mkrityb">→</span><span data-id="element-107" data-mp="2c6grn2xazxuk">Sin dos comidas</span><span className="text-slate-600" data-id="element-108" data-mp="1yd7mjege1yhu">→</span><span data-id="element-109" data-mp="1yc6ab6nmz5yj">Sin peleas</span><span className="text-slate-600" data-id="element-110" data-mp="1ycpivwrechzw">→</span><span data-id="element-111" data-mp="22eb36369fyk4">Comen más nutritivo</span>
          </div>
        </div>

        <div className="mb-10" data-id="element-112" data-mp="22c6ocq6tpf52">
          <h3 className="text-xl font-bold text-white mb-5 flex items-center gap-3" data-id="element-113" data-mp="1oe8mgk9ovb6g">
            <Salad className="w-8 h-8 text-brand-400" data-id="element-114" data-mp="1tdla378dwma3" /> Cada tomo resuelve un momento de la comida
          </h3>
          <p className="text-slate-400 text-sm leading-relaxed mb-5" data-id="element-115" data-mp="1feljvv583zbt">
            No todas las familias pelean por lo mismo: algunos chicos rechazan la cebolla en la carne, otros no quieren nada verde en la pizza y otros solo aceptan snacks. Por eso el Megapack está dividido en seis tomos, uno para cada tipo de comida que ya forma parte de tu semana.
          </p>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-116" data-mp="3drdk4zc9uq4t">
            {tomos.map((tomo, i) => <Card key={i} className={`border ${tomo.color}`} data-id="element-117" data-mp="2p0zdexwqhwhu" data-mpi={i}>
                <div className="flex items-start gap-4" data-id="element-118" data-mp="2k5abwp15m5iw">
                  <div className="p-3 bg-slate-900 rounded-xl shrink-0" data-id="element-119" data-mp="2f4mdvjeicof6">{tomo.icon}</div>
                  <div data-id="element-120" data-mp="2a5t86d5gq1pk">
                    <h4 className="font-bold text-white text-lg mb-1" data-id="element-121" data-mp="2a6ku0w99cl2n">{tomo.title}</h4>
                    <p className="text-brand-400 text-sm font-medium mb-3" data-id="element-122" data-mp="263y0mqwxus3c">{tomo.subtitle}</p>
                    <p className="text-slate-400 text-sm leading-relaxed" data-id="element-123" data-mp="21drces6c99lm">{tomo.desc}</p>
                  </div>
                </div>
              </Card>)}
          </div>
        </div>

        <Card className="bg-slate-900" data-id="element-124" data-mp="1rfjxeevm11m9">
          <h4 className="font-bold text-xl text-white mb-6" data-id="element-125" data-mp="1rgmmch9dgtzj">En cada receta encontrarás:</h4>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-126" data-mp="1mf5okum6pnn6">
            {['Ingredientes fáciles de conseguir en cualquier verdulería', 'Paso a paso claro, pensado para el día a día', 'Cantidades exactas para no arriesgar el resultado', 'Qué verdura utilizar en cada preparación', 'Cómo procesarla para que quede totalmente integrada', 'Cómo lograr buena textura sin que se note', 'Cómo conservar el sabor que ya les gusta', 'Alternativas para reemplazar ingredientes que no tengas'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-127" data-mp="3afsyp2mjxd4t" data-mpi={i}>
                <CheckCircle className="w-5 h-5 text-brand-400 shrink-0 mt-0.5" data-id="element-128" data-mp="3fcb1vy28h3f1" />
                <span className="text-slate-300" data-id="element-129" data-mp="3kbnku7pzhqcc">{item}</span>
              </div>)}
          </div>
        </Card>
      </div>
    </section>;
}
export function Bonuses() {
  const bonuses = [{
    title: 'Menú Familiar de 60 Días',
    desc: 'Dos meses de comidas ya organizadas para no volver a improvisar a las 12 del mediodía.',
    value: '$8.000'
  }, {
    title: 'Freezer Inteligente',
    desc: 'Cómo preparar, porcionar y congelar para tener comidas nutritivas siempre listas.',
    value: '$8.000'
  }, {
    title: 'Manual de Verduras Invisibles',
    desc: 'Qué verdura va en cada receta, cómo procesarla y cómo lograr que desaparezca.',
    value: '$9.000'
  }, {
    title: 'Lunch Escolar',
    desc: 'Ideas prácticas para la vianda y el recreo que llegan enteras y las comen completas.',
    value: '$8.000'
  }, {
    title: 'Cómo Reemplazar Ingredientes sin Arruinar la Receta',
    desc: 'Equivalencias simples para cocinar con lo que ya tenés en casa.',
    value: '$9.000'
  }];
  return <section className="py-12 px-4" data-id="element-130" data-mp="21nsf6prh2vgk">
      <div className="max-w-5xl mx-auto" data-id="element-131" data-mp="2flgxpqy2hqig">
        <div className="text-center mb-8" data-id="element-132" data-mp="2fj48cspzcdvd">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 flex items-center justify-center gap-3" data-id="element-133" data-mp="2alku3sta813f">
            <Gift className="w-9 h-9 text-brand-400" data-id="element-134" data-mp="3qzb0x7bsd3gr" />5 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-brand-400 font-bold uppercase tracking-widest" data-id="element-135" data-mp="3m22gt172upcv">Siempre incluidos</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-4 mb-8" data-id="element-136" data-mp="17sqhen0g9tpn">
          {bonuses.map((bono, i) => <Card key={i} className={`relative overflow-hidden group hover:border-brand-500/50 transition-colors lg:col-span-2 ${i === 3 ? 'lg:col-start-2' : ''}`} data-id="element-137" data-mp="1cu61ocuszw6z" data-mpi={i}>
              <div className="absolute top-0 right-0 bg-brand-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-138" data-mp="13r4x4gll6d5f">BONO {i + 1}</div>
              <h4 className="font-bold text-white text-lg mb-3 pr-12 mt-2" data-id="element-139" data-mp="1riao9rwz8rv1">{bono.title}</h4>
              <p className="text-slate-400 text-sm mb-6" data-id="element-140" data-mp="1vikth2cy3e8u">{bono.desc}</p>
              <div className="mt-auto pt-4 border-t border-slate-800 flex justify-between items-center" data-id="element-141" data-mp="1hshcapsxaaq9">
                <span className="line-through text-slate-500 text-sm" data-id="element-142" data-mp="1mpqyzxoxg8ae">Valor {bono.value}</span>
                <span className="text-brand-400 font-bold" data-id="element-143" data-mp="2ag3i84pmhrga">GRATIS</span>
              </div>
            </Card>)}
        </div>

        <div className="bg-slate-900 border border-brand-500/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-144" data-mp="2f8egz48mn779">
          <p className="text-slate-300 mb-2" data-id="element-145" data-mp="f6wxid0fmc7q">Valor total bonos</p>
          <p className="text-4xl font-black text-white mb-2 line-through decoration-red-500/50" data-id="element-146" data-mp="adc1urmb9ubp">$42.000</p>
          <p className="text-2xl font-bold text-brand-400" data-id="element-147" data-mp="5fk77pua7u3t">→ GRATIS con tu Megapack completo</p>
        </div>
      </div>
    </section>;
}